import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LicensePageMetaContentRegular = _resolveComponent("LicensePageMetaContentRegular")!

  return (_openBlock(), _createBlock(_component_LicensePageMetaContentRegular, {
    class: _normalizeClass(_ctx.classes),
    content: _ctx.content.label
  }, null, 8, ["class", "content"]))
}